import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_HOST + process.env.REACT_APP_API_DOMAIN + process.env.REACT_APP_API_VERSION;
const BASE_URL_2 = process.env.REACT_APP_API_HOST_2 + process.env.REACT_APP_API_DOMAIN + process.env.REACT_APP_API_VERSION;

export function apiCall(
  method,
  url,
  params,
  headers,
  data,
  alternate,
) {
  return axios({
    method,
    url: alternate ? `${BASE_URL_2}${url}` : `${BASE_URL}${url}`,
    params,
    headers,
    data,
  });
}

export function authApiCall(
  method,
  url,
  params,
  headers,
  data,
) {
  return axios({
    method,
    url: `${url}`,
    params,
    headers,
    data,
  });
}

// {
//   "fiscalCode": "MRTMTT91D08F205J",
//   "pod": "IT001E14497860",
//   "productFamily": "SPLIT_CHARGE"
// }
